import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import ButtonFont from '../../../../Theme/Fonts/Button'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import LinkProps from '../../../../Link/LinkProps'

type BasicTextButtonProps = {
    children: string
    href?: string
    onPress?: () => void
    expand?: boolean
    paddingX?: number
    height?: number | string
    color?: 'pearl' | 'onyx' | 'WHITE'
} & LinkProps &
    TestID

const BasicTextButton: FunctionComponent<BasicTextButtonProps> = ({
    children,
    color = 'onyx',
    href,
    onPress,
    expand = false,
    paddingX,
    height,
    testID,
    webRel,
}): ReactElement => {
    return (
        <Grid horizontal={!expand} noExpand testID={testID}>
            <Touchable onPress={onPress} href={href} webRel={webRel}>
                <Grid height={height} paddingX={paddingX} noExpand centerVertical>
                    <ButtonFont color={color}>{children}</ButtonFont>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(BasicTextButton)
